import { getCheckbox } from '../checkboxDetection'

async function toggleRadioButton(targetSettingsText: string, nodeName = '*') {
  const button = await getCheckbox(targetSettingsText, nodeName)

  if (!button) {
    throw new Error(
      `Could not find radio button for target setting ${targetSettingsText}`,
    )
  }
  return button.click()
}

async function getCurrentValueForRadioButtons(mapToSettingsLabel: {
  [key: string]: string
}): Promise<string> {
  const settingsLabels = Object.values(mapToSettingsLabel)
  const buttonsPromises = settingsLabels.map((setting) => getCheckbox(setting))
  const buttons = await Promise.all(buttonsPromises)
  const selectedButton = buttons.find((button) => button.checked)
  return selectedButton.labels[0].outerText
}

async function saveCurrentValueForRadioButtons(
  updateStoredInitialValuesFn: (
    obj: { [key: string]: any },
    key?: string,
  ) => Promise<void>,
  mapToSettingsLabel: { [key: string]: string },
  settingKey: string,
  recommendationKey: string,
): Promise<void> {
  const currentSelectedSetting =
    await getCurrentValueForRadioButtons(mapToSettingsLabel)
  return updateStoredInitialValuesFn(
    {
      [settingKey]: currentSelectedSetting,
    },
    recommendationKey,
  )
}

export {
  saveCurrentValueForRadioButtons,
  getCurrentValueForRadioButtons,
  toggleRadioButton,
}
